<template>
  <div id="Software">
    <img src="@/assets/images/pic200-12.png" style="width: 100%; height: auto" alt="" />
    <div class="flex">
      <div class="text">
该方案运用大数据等现代信息技术，加快推进部门间信息共享和业务协同，实现政府日常事务信息化办公、行政事务信息化办理、人员基本信息管理，促进各业务部门之间的业务协同与信息共享；实现项目全生命周期的全程监管、实现项目信息共享及部门协同运作、降低项目风险、提升领导决策支撑能力；同时解决群众办事过程中“办证多、办事难”等问题。主要内容包括互联网+便民服务云平台、互联网+GIS投资管理平台和互联网+政府OA办公系统。      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}

.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 40px;
  text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution13.vue